// src/features/fourlink-config/components/blocks/Block1Steps/TipologiasStep.jsx

import React, { useMemo, useState } from 'react';
import { CommentButton } from '../../shared/CommentButton';
import { CentroForm } from '../../forms/CentroForm';
import { FileUpload } from '../../forms/FileUpload';

export const TipologiasStep = ({
  tipologiasDisponibles,
  hiddenTipologias,
  selectedTipologias,
  centros,
  onToggleTipologia,
  onAddTipologia,
  onHideTipologias,
  onRestoreTipologia,
  onAddCentro,
  onAddCentrosFromExcel,
  onDeleteCentro,
  onCommentClick,
  hasComment,
}) => {
  const tipologiasSectionKey = 'section:tipologias';
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isHideModalOpen, setIsHideModalOpen] = useState(false);
  const [newTipologiaName, setNewTipologiaName] = useState('');
  const [tipologiasToHide, setTipologiasToHide] = useState([]);

  const tipologiasVisibles = useMemo(
    () => (Array.isArray(tipologiasDisponibles) ? tipologiasDisponibles : []),
    [tipologiasDisponibles],
  );

  const hiddenList = useMemo(
    () => (Array.isArray(hiddenTipologias) ? hiddenTipologias : []),
    [hiddenTipologias],
  );

  const toggleTipologiaToHide = (tipologia) => {
    setTipologiasToHide((prev) =>
      prev.includes(tipologia) ? prev.filter((t) => t !== tipologia) : [...prev, tipologia],
    );
  };

  const handleConfirmHide = () => {
    if (typeof onHideTipologias === 'function' && tipologiasToHide.length > 0) {
      onHideTipologias(tipologiasToHide);
    }
    setTipologiasToHide([]);
    setIsHideModalOpen(false);
  };

  const handleCreateTipologia = (e) => {
    e.preventDefault();
    if (!newTipologiaName.trim()) return;
    const created = typeof onAddTipologia === 'function'
      ? onAddTipologia(newTipologiaName.trim())
      : false;
    if (created) {
      setNewTipologiaName('');
      setIsAddModalOpen(false);
    }
  };

  const handleCloseAddModal = () => {
    setIsAddModalOpen(false);
    setNewTipologiaName('');
  };

  const handleCloseHideModal = () => {
    setIsHideModalOpen(false);
    setTipologiasToHide([]);
  };

  const renderModalShell = (children) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 px-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg p-6 relative">
        {children}
      </div>
    </div>
  );
  
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between gap-4">
        <h2 className="text-3xl font-bold" style={{ color: '#1a365d' }}>
          Tipologias de Centros
        </h2>
        <div className="flex items-center gap-3">
          {hasComment && (
            <span className="text-xs font-semibold text-blue-700">Comentario guardado</span>
          )}
          <button
            type="button"
            onClick={() => setIsHideModalOpen(true)}
            className="relative inline-flex items-center justify-center w-10 h-10 rounded-full border border-red-200 text-red-700 bg-white hover:bg-red-50 transition-colors font-semibold"
            title="Ocultar tipología"
          >
            <span className="sr-only">Ocultar tipología</span>
            <span className="text-lg leading-none font-bold">-</span>
          </button>
          <button
            type="button"
            onClick={() => setIsAddModalOpen(true)}
            className="relative inline-flex items-center justify-center w-10 h-10 rounded-full border border-green-200 text-green-700 bg-white hover:bg-green-50 transition-colors"
            title="Añadir nueva tipología"
          >
            <span className="text-lg leading-none font-bold">+</span>
            <span className="sr-only">Anadir tipologia</span>
          </button>
          <CommentButton
            onClick={() => onCommentClick({ key: tipologiasSectionKey, label: 'Tipologías de Centros' })}
            hasComment={hasComment}
            srLabel="Añadir comentario para Tipologías de Centros"
            variant="circle"
            className="border-blue-200 text-blue-700 bg-white hover:bg-blue-50"
          />
        </div>
      </div>

      <p className="text-gray-600 mb-6 text-lg">
        Selecciona las tipologias de centros que aplican al cliente:
      </p>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-8">
        {tipologiasVisibles.length > 0 ? (
          tipologiasVisibles.map((tipologia) => (
            <button
              key={tipologia}
              onClick={() => onToggleTipologia(tipologia)}
              className={`p-4 rounded-xl border-2 transition-all font-medium ${
                selectedTipologias.includes(tipologia)
                  ? 'border-blue-500 text-white shadow-lg'
                  : 'border-gray-200 hover:border-blue-300 bg-white text-gray-700'
              }`}
              style={{
                backgroundColor: selectedTipologias.includes(tipologia) ? '#3182ce' : undefined,
              }}
            >
              {tipologia}
            </button>
          ))
        ) : (
          <div className="col-span-full text-gray-500 italic">No hay tipologías de centro disponibles.</div>
        )}
      </div>

      {selectedTipologias.length > 0 && (
        <div className="mt-8">
          <h3 className="text-lg font-semibold mb-4">Agregar Centros</h3>
          
          <FileUpload
            onFileProcessed={onAddCentrosFromExcel}
            selectedTipologias={selectedTipologias}
          />
          
          <div className="flex items-center gap-4 mb-6 mt-6">
            <hr className="flex-1 border-gray-300" />
            <span className="text-gray-500 text-sm font-medium">O agregar individualmente</span>
            <hr className="flex-1 border-gray-300" />
          </div>

          <CentroForm
            selectedTipologias={selectedTipologias}
            centros={centros}
            onAddCentro={onAddCentro}
            onDeleteCentro={onDeleteCentro}
          />

        </div>
      )}

      {isAddModalOpen && renderModalShell(
        <div className="space-y-4">
          <div className="flex items-start justify-between">
            <div>
              <h3 className="text-xl font-semibold text-gray-900">Añadir tipología</h3>
              <p className="text-sm text-gray-600">Crea nuevas tipologías y revisa las que has ocultado.</p>
            </div>
            <button
              type="button"
              className="text-gray-500 hover:text-gray-800"
              onClick={handleCloseAddModal}
              aria-label="Cerrar modal de añadir tipología"
            >
              ✕
            </button>
          </div>

          <form onSubmit={handleCreateTipologia} className="space-y-3">
            <label className="block text-sm font-medium text-gray-700" htmlFor="nueva-tipologia-input">
              Nombre de la tipología
            </label>
            <input
              id="nueva-tipologia-input"
              type="text"
              value={newTipologiaName}
              onChange={(e) => setNewTipologiaName(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Ej. Clínica pediátrica"
            />
            <div className="flex justify-end gap-2">
              <button
                type="button"
                onClick={handleCloseAddModal}
                className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50"
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="px-4 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 disabled:opacity-60"
                disabled={!newTipologiaName.trim()}
              >
                Añadir tipología
              </button>
            </div>
          </form>

          <div className="border-t pt-4">
            <h4 className="text-sm font-semibold text-gray-800 mb-2">Tipologías ocultas</h4>
            {hiddenList.length === 0 ? (
              <p className="text-sm text-gray-500">No hay elementos ocultos.</p>
            ) : (
              <ul className="space-y-2 max-h-48 overflow-y-auto pr-1">
                {hiddenList.map((item) => (
                  <li key={item} className="flex items-center justify-between bg-gray-50 rounded-lg px-3 py-2">
                    <span className="text-sm text-gray-800">{item}</span>
                    {typeof onRestoreTipologia === 'function' && (
                      <button
                        type="button"
                        onClick={() => onRestoreTipologia(item)}
                        className="text-xs px-3 py-1 rounded-full border border-blue-200 text-blue-700 hover:bg-blue-50"
                      >
                        Restaurar
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}

      {isHideModalOpen && renderModalShell(
        <div className="space-y-4">
          <div className="flex items-start justify-between">
            <div>
              <h3 className="text-xl font-semibold text-gray-900">Ocultar tipologías</h3>
              <p className="text-sm text-gray-600">Selecciona las tipologías que quieras ocultar temporalmente.</p>
            </div>
            <button
              type="button"
              className="text-gray-500 hover:text-gray-800"
              onClick={handleCloseHideModal}
              aria-label="Cerrar modal de ocultar tipologías"
            >
              ✕
            </button>
          </div>

          {tipologiasVisibles.length === 0 ? (
            <p className="text-sm text-gray-500">No hay tipologías disponibles para ocultar.</p>
          ) : (
            <div className="space-y-2 max-h-64 overflow-y-auto pr-1">
              {tipologiasVisibles.map((tipologia) => (
                <label
                  key={tipologia}
                  className="flex items-center justify-between border border-gray-200 rounded-lg px-3 py-2 hover:border-blue-200"
                >
                  <div className="flex items-center gap-3">
                    <input
                      type="checkbox"
                      checked={tipologiasToHide.includes(tipologia)}
                      onChange={() => toggleTipologiaToHide(tipologia)}
                      className="h-4 w-4 text-blue-600 border-gray-300 rounded"
                    />
                    <span className="text-sm text-gray-800">{tipologia}</span>
                  </div>
                  {selectedTipologias.includes(tipologia) && (
                    <span className="text-xs text-blue-600 font-medium">Seleccionada</span>
                  )}
                </label>
              ))}
            </div>
          )}

          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={handleCloseHideModal}
              className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50"
            >
              Cancelar
            </button>
            <button
              type="button"
              onClick={handleConfirmHide}
              className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 disabled:opacity-60"
              disabled={tipologiasToHide.length === 0}
            >
              Ocultar seleccionadas
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
